The identifier for the `WebhookSubscriptionReplay`.
